import { NgModule } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ChartsModule } from '../../shared/charts/charts.module';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../global/pipes/pipes.module';
import { TaxDetailsComponent } from './tax-details.component';
import { TaxDetailsEffects } from './tax-details.effects';
import { FieldModule } from 'atlas-field';
import { IconModule } from 'atlas-icon';
import { LegacyModule } from 'atlas-legacy';
import { TableModule } from 'atlas-table';
import { CdkModule } from 'atlas-cdk';
import { TooltipModule } from 'atlas-tooltip';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';

export const COMPONENTS = [
    TaxDetailsComponent
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // // MercerOSModule,
        ChartsModule,
        SharedModule,
        PipesModule,
        FieldModule,
        IconModule,
        LegacyModule,
        TableModule,
        CdkModule,
        TooltipModule,
        MenuModule,
        ListModule,
        LinkModule,
        EffectsModule.forFeature([TaxDetailsEffects])
    ],
    exports: COMPONENTS,
    providers: [DecimalPipe],
    bootstrap: [],
})
export class TaxDetailsModule {
}
